export function uppercase(value: string): string {
  return value.toUpperCase();
}

export function clean(value: string): string {
  return value.replace('[GraphQL] ', '').replace('[Network] ', '').trim();
}
